import {Modal} from './modal.js'
import { UI } from '../lib/ui.js'
export class Form {
    constructor(endpoint, form = null) {
        const ui = window.ui ? window.ui : new UI
        this.form = form
        this.endpoint = ui.endpoint
        this.id = null
    }
    /**0
     * 
     * @returns 
     */
    get(callback) {
      if(!this.form) {
        this.fetch().then(res => res.text()).then((form) => {
          this.form = form
          if(!this.isElement(this.form)){
            const parser = new DOMParser()
             this.form = parser.parseFromString(form, 'text/html').querySelector('form')
             callback(this.form)
          }
        })
      }else{
        callback(this.form)
      }
    }
    /**
     * 
     * @param {*} callback 
     */
    data(callback) {
      if(this.id)
        fetch('/api/data/'+this.endpoint+'/'+this.id).then(res => res.text()).then((data) => callback(data))
      else
        fetch('/api/data/'+this.endpoint).then(res => res.text()).then((data) => callback(data))
    }
    /**
     * 
     * @param {*} action 
     * @returns 
     */
    modal(action) {
      const modal = new Modal('bootstrapModal')
      return modal.instance({
        title : action + ' ' +this.endpoint,
        body : this.form
      })
    }
    /**
     * 
     * @param {*} obj 
     * @returns 
     */
    isElement(obj) {
        try {
          return obj instanceof HTMLElement;
        }
        catch(e){
          return (typeof obj==="object") &&
            (obj.nodeType===1) && (typeof obj.style === "object") &&
            (typeof obj.ownerDocument ==="object");
        }
      }
      /**
       * 
       * @returns 
       */
      fetch() {
        return fetch(`form/${this.endpoint}`)
      }
}